import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "./vouchers-distribution.api";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseCreateVoucherOrderOptions = {
  config?: MutationConfig<typeof vouchersDistributionsRepository.createVoucherOrder>;
};

export const useCreateVoucherOrder = ({ config }: UseCreateVoucherOrderOptions) => {
  const { i18n } = useTranslation();

  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.createVoucherOrder({ ...data, locale: i18n.language }),
  });
};
